import React from 'react';
import { Stack } from 'expo-router';

export default function AuthGroupLayout() {
  return <Stack screenOptions={{ headerShown: false }} />;
}
